import * as Yup from "yup";

export const NumDayInitialState = {
  currentDay: "",
};

export const NumDayValidationSchema = Yup.object({
  currentDay: Yup.string().required("Este campo es requerido"),
});
